// Whether `hitId` — a PR profile hit's id, which IS the underlying Id::Profile id — belongs to
// the signed-in viewer. Mirrors media_profiles/card/messageGating.js's "never yourself" rule; PR
// profiles have no messaging-policy restriction beyond that (any signed-in viewer may message any
// PR profile), so this only needs the self-exclusion, not a full gate.
export default function isOwnPrProfile(hitId) {
  const currentProfileId = globalThis.Qwoted?.CURRENT_PROFILE_ID;
  return hitId != null && currentProfileId != null && String(hitId) === String(currentProfileId);
}
